import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './Notification.module.css';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import useBackdrop from '../../../hooks/useBackdrop';
import useModal from '../../../hooks/useModal';

import { IModal } from '../../../types/modal';
import { Notification } from '../../../types/main';
import { NO_NEW_NOTIFICATION } from '../../../constants';

import {
  notificationsChanged,
  selectNotifications,
} from '../../../features/mainSlice';

export default function NotificationModal(props: IModal) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { toggleModal } = useModal();

  const notifications = useAppSelector(selectNotifications);
  const modalRef = useRef<HTMLDivElement>(null);

  const setNotificationList = (selectedCode: string) => {
    const newNotificationList = notifications?.filter(
      ({ code }) => code !== selectedCode
    );
    dispatch(notificationsChanged(newNotificationList));
  };

  const movePage = (code: string) => {
    const path =
      code === '100' || code === '' || code === '400'
        ? '/home/settings/storage'
        : code === '200'
        ? '/home/settings/sharedLink'
        : code === '500'
        ? '/home/classroom/class'
        : '/home/settings/student-registration-request';
    navigate(path);
    toggleModal({
      id: 'notification',
      type: 'notification',
    });

    setNotificationList(code);
  };

  useBackdrop(props, modalRef, { isScroll: true, buttonClass: 'notification' });

  return (
    <div className={cx('msg_layer', 'notice')} ref={modalRef}>
      <div className={cx('inner')}>
        {notifications?.length ? (
          notifications.map(({ code, msg }: Notification) => (
            <p key={code} className={cx('txt')} onClick={() => movePage(code)}>
              {msg}
            </p>
          ))
        ) : (
          <p>{NO_NEW_NOTIFICATION}</p>
        )}
      </div>
    </div>
  );
}
